<template>
  <div class="address-header">
    <div><strong>{{ clientInfo.name }}</strong></div>
    <div>({{ clientInfo.retailerId }})</div>
    <div>{{ clientInfo.address }}</div>
    <div>{{ clientInfo.zip }} {{ clientInfo.city }}</div>
  </div>
</template>

<script>
export default {
  props: {
    clientInfo:         { type: Object, default: undefined },
  }
}
</script>
